// extracted by mini-css-extract-plugin
export default {"profile-relation":"Badge_profile-relation__JotIi","beige":"Badge_beige__VsrQV","green":"Badge_green__yT5h+","blue":"Badge_blue__qh1SU","purple":"Badge_purple__KoDy1"};